const REDUX_STATUS = {
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  SAVING: 'SAVING',
  SUCCESS: 'SUCCESS'
}

export default REDUX_STATUS
